import { makeVar } from '@apollo/client';

import { Wishlist } from './types';

export const wishlistVar = makeVar<Wishlist>({
	wishlistItems: [],
	travelItineraryId: null
});
